import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'neutral'
    | 'surface'
    | 'choice'
    | 'choiceSelected'
    | 'ghost';
  size?: 'bare' | 'sm' | 'md' | 'lg' | 'icon';
  shape?: 'rounded' | 'square';
  fullWidth?: boolean;
};

const variants = {
  primary: 'bg-[#631d76] text-white hover:bg-[#522064] focus-visible:ring-[#631d76]',
  secondary: 'bg-emerald-600 text-white hover:bg-emerald-700 focus-visible:ring-emerald-600',
  danger: 'bg-orange-500 text-white hover:bg-orange-600 focus-visible:ring-orange-500',
  neutral: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus-visible:ring-gray-400',
  surface:
    'border-2 border-gray-200 bg-white text-[#535d7e] hover:bg-gray-50 focus-visible:ring-gray-400',
  choice:
    'border border-gray-200 bg-white text-gray-900 hover:border-gray-400 focus-visible:ring-[#631d76]',
  choiceSelected:
    'border border-[#631d76] bg-purple-50 text-gray-900 ring-1 ring-[#631d76] focus-visible:ring-[#631d76]',
  ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus-visible:ring-gray-400',
};

const sizes = {
  bare: '',
  sm: 'min-h-9 px-3 py-1.5 text-sm',
  md: 'min-h-11 px-5 py-2.5',
  lg: 'min-h-14 px-5 py-4 text-base',
  icon: 'h-10 w-10 p-0',
};

export const Button = ({
  variant = 'primary',
  size = 'md',
  shape = 'rounded',
  fullWidth,
  className = '',
  ...props
}: Props) => (
  <button
    {...props}
    className={`inline-flex items-center justify-center font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${shape === 'rounded' ? 'rounded' : 'rounded-none'} ${sizes[size]} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
  />
);
